const { makeApiRequest, api } = require('./_init')

const tasksApi = {
  getTaskStatus: async (taskId) => {
    return await makeApiRequest(api, 'get', `/tasks/${taskId}`)
  },
}

export default tasksApi
